export class MagazineHomeController {
  private loadMore: HTMLElement | null = document.querySelector('.js-magazineHomeLoadmore');
  private tagLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.js-magazineHome-tagLinks');
  private articles: NodeListOf<HTMLElement> = document.querySelectorAll('.article');
  private visibleArticle = 6;

  constructor() {
    const articleSlider = document.querySelector('.js-articleSlider') as HTMLElement;
    this.tagLinks.forEach((tagLink) => {
      tagLink.addEventListener('click', (event) => {
        event.preventDefault();
        const target = event.target as HTMLElement;

        if (target instanceof HTMLElement) {
          if (!target.classList.contains('magazineHome__filterTag--active')) {
            target.classList.add('magazineHome__filterTag--active');
          } else {
            target.classList.remove('magazineHome__filterTag--active');
          }
        }

        this.visibleArticle = 6;
        this.showArticles();
        this.showArticleSlider(articleSlider);
        this.updateURL();
      });
    });

    if (this.loadMore) {
      this.loadMore.addEventListener('click', () => {
        this.visibleArticle += 6;
        this.showArticles();
        this.showArticleSlider(articleSlider);
      });
    }

    this.setTagsFromURL();
    this.showArticles();
    if (articleSlider) {
      this.showArticleSlider(articleSlider);
    }
  }

  private setTagsFromURL() {
    const urlFragment = window.location.hash.slice(1);
    const urlParams = new URLSearchParams(window.location.search);
    const tagsFromParams = urlParams.get('data-tags');
    if (tagsFromParams) {
      const tagElement = document.querySelector(`[data-tag="${tagsFromParams}"]`);
      if (tagElement) {
        tagElement.classList.add('magazineHome__filterTag--active');
      }
    }
    if (urlFragment) {
      const tagIds = urlFragment.split(',');
      tagIds.forEach((id) => {
        const tagElement = document.querySelector(`[data-tag="${id}"]`);
        if (tagElement) {
          tagElement.classList.add('magazineHome__filterTag--active');
        }
      });
    }
  }

  private updateURL() {
    const activeTags = document.querySelectorAll('.magazineHome__filterTag--active');
    const activeTagIds = Array.from(activeTags)
      .map((tagElement) => tagElement.getAttribute('data-tag'))
      .filter((tagId) => tagId !== null);

    window.location.hash = activeTagIds.join(',');
  }

  private showArticles() {
    const activeTags = document.querySelectorAll('.magazineHome__filterTag--active');
    const matchingArticles: HTMLElement[] = [];

    this.articles.forEach((article) => {
      const articleTags: number[] = JSON.parse(article.dataset.tags || '[]');

      if (activeTags.length === 0) {
        matchingArticles.push(article);
      } else {
        const matchesFilter = Array.from(activeTags).some((tagElement) => {
          const filterTag = tagElement.getAttribute('data-tag');
          return articleTags.includes(Number(filterTag));
        });

        if (matchesFilter) {
          matchingArticles.push(article);
        }
      }
    });

    this.articles.forEach((article) => article.classList.add('hide'));

    matchingArticles.slice(0, this.visibleArticle).forEach((article) => {
      article.classList.remove('hide');
    });

    if (this.loadMore) {
      if (matchingArticles.length > this.visibleArticle) {
        this.loadMore.classList.remove('hide');
      } else {
        this.loadMore.classList.add('hide');
      }
    }
  }

  private showArticleSlider(articleSlider: HTMLElement) {
    let articles = articleSlider.querySelectorAll('.article');
    articles.forEach((article) => {
      article.classList.remove('hide');
    });
  }
}
